import {configureStore} from '@reduxjs/toolkit'
import appReducer from '@redux/app/appSlice'
import converstationReducer from '@redux/conversation/converstationSlice'
import mapReducer from '@redux/map/mapSlice'
import mixpanelReducer from '@redux/mixpanel/mixpanelSlice'
import gymReducer from '@redux/gym/gymSlice'
import notebookReducer from '@redux/notebook/notebookSlice'
import examResult from '@redux/exam-result/examResult'
import revise from '@redux/revise/revise'
import vocabulary from '@redux/vocabulary/vocabulary'
import shared from '@redux/shared/shared'
import learnPartTwo from '@redux/learn-part-two/learnPartTwo'
import learnPartThree from '@redux/learn-part-three/learnPartThree'
import paraphraseReducer from '@redux/paraphrase/paraphraseSlice'
const store = configureStore({
  reducer: {
    shared: shared,
    app: appReducer,
    converstation: converstationReducer,
    map: mapReducer,
    mixpanel: mixpanelReducer,
    gym: gymReducer,
    notebook: notebookReducer,
    examResult: examResult,
    revise: revise,
    vocabulary: vocabulary,
    learnPartTwo: learnPartTwo,
    learnPartThree: learnPartThree,
    paraphrase: paraphraseReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export default store
